(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-registration/assets/helpers/tracking.js') >= 0) return;  svs.modules.push('/modules/player-registration/assets/helpers/tracking.js');
'use strict';

const trackCustomerRegistrationAsync = _ref => {
  let {
    label,
    duration
  } = _ref;
  return new Promise(resolve => {
    try {
      svs.components.analytics.trackEvent([{
        category: 'Users',
        action: 'Customer Registration',
        opt_label: label,
        opt_value: '0'
      }, {
        category: 'Users',
        action: 'Customer Registration',
        opt_label: "intermediate_duration_".concat(label),
        opt_value: duration
      }], () => {
        svs.core.userSession.set('playerRegistration_isNewCustomer', true, () => {
          resolve({
            success: true
          });
        });
      });
    } catch (error) {
      svs.playerRegistration.logger.warn('Could not track event', error);
      resolve({
        error
      });
    }
  });
};
const trackKycSavingAsync = _ref2 => {
  let {
    duration
  } = _ref2;
  return new Promise(resolve => {
    try {
      svs.components.analytics.trackEvent([{
        category: 'Users',
        action: 'Customer Registration',
        opt_label: 'total_duration',
        opt_value: duration
      }], () => resolve({
        success: true
      }));
    } catch (error) {
      svs.playerRegistration.logger.warn('Could not track event', error);
      resolve({
        error
      });
    }
  });
};
svs.playerRegistration.tracking = {
  trackCustomerRegistrationAsync,
  trackKycSavingAsync
};

 })(window);